import { apiSlice } from './apiSlice';

interface CreateAdministratorRequest {
  username: string;
  password: string;
}

export const setupApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Creates the one administrator on a server that has none.
     *
     * It invalidates `Config`, which is what moves the panel on: `setupRequired` comes back false
     * and the router stops sending everything to the setup screen. Deliberately no toast on
     * success, because the screen changes underneath the person and a notification about a page
     * they are no longer on is noise. Failures are surfaced on the form itself, where the field
     * they refer to is.
     */
    createAdministrator: builder.mutation<void, CreateAdministratorRequest>({
      query: (administrator) => ({
        url: '/v1/setup/administrator',
        method: 'POST',
        body: administrator,
      }),
      invalidatesTags: ['Config'],
    }),
  }),
});

export const { useCreateAdministratorMutation } = setupApiSlice;
